const HAS_SEEN_PREVIEW_KEY = '@budget_has_seen_preview';

export async function getHasSeenPreview(): Promise<boolean> {
  try {
    return window.localStorage.getItem(HAS_SEEN_PREVIEW_KEY) === 'true';
  } catch {
    return false;
  }
}

export async function setHasSeenPreview(seen: boolean): Promise<void> {
  try {
    window.localStorage.setItem(HAS_SEEN_PREVIEW_KEY, seen ? 'true' : 'false');
  } catch {
    // Non-fatal — preview can still proceed in-session
  }
}
